import {
	listAssessments,
	getAssessment,
	createAssessment,
	updateAssessment,
	deleteAssessment,
	publishAssessment,
	generateAiAssessment,
	approveAiAssessment,
	rejectAiAssessment,
	listCategories,
	createCategory,
	updateCategory,
	deleteCategory,
	listCertifications,
	listAssessmentActivity,
	listCareerTrailActivity,
	listCareerTrails,
	getCareerTrail,
	createCareerTrail,
	updateCareerTrail,
	deleteCareerTrail,
	storeTrailLevel,
	updateTrailLevel,
	deleteTrailLevel,
	storeTrailStep,
	updateTrailStep,
	deleteTrailStep,
} from '@/services/academy/assessments.service'

export default {
	namespaced: true,
	state: {
		// Assessments
		list:        { data: [], meta: { pagination: { total: 0 } } },
		listStatus:  'init',
		current:     null,
		currentStatus: 'init',
		actionStatus: 'init',
		// Categories
		categories:       [],
		categoriesStatus: 'init',
		// Certifications
		certifications:       { data: [], meta: { pagination: { total: 0 } } },
		certificationsStatus: 'init',
		// Career Trails
		trails:       { data: [], meta: { pagination: { total: 0 } } },
		trailsStatus: 'init',
		currentTrail: null,
		currentTrailStatus: 'init',
		// Live Activity
		assessmentActivity:       { data: [], meta: { pagination: { total: 0 } } },
		assessmentActivityStatus: 'init',
		trailActivity:            { data: [], meta: { pagination: { total: 0 } } },
		trailActivityStatus:      'init',
	},
	getters: {
		getList:               (s) => s.list,
		getListStatus:         (s) => s.listStatus,
		getCurrent:            (s) => s.current,
		getCurrentStatus:      (s) => s.currentStatus,
		getActionStatus:       (s) => s.actionStatus,
		getCategories:         (s) => s.categories,
		getCategoriesStatus:   (s) => s.categoriesStatus,
		getCertifications:     (s) => s.certifications,
		getCertificationsStatus: (s) => s.certificationsStatus,
		getTrails:             (s) => s.trails,
		getTrailsStatus:       (s) => s.trailsStatus,
		getCurrentTrail:       (s) => s.currentTrail,
		getCurrentTrailStatus: (s) => s.currentTrailStatus,
		getAssessmentActivity:       (s) => s.assessmentActivity,
		getAssessmentActivityStatus: (s) => s.assessmentActivityStatus,
		getTrailActivity:            (s) => s.trailActivity,
		getTrailActivityStatus:      (s) => s.trailActivityStatus,
	},
	mutations: {
		SET_LIST(s, v)              { s.list = v },
		SET_LIST_STATUS(s, v)       { s.listStatus = v },
		SET_CURRENT(s, v)           { s.current = v },
		SET_CURRENT_STATUS(s, v)    { s.currentStatus = v },
		SET_ACTION_STATUS(s, v)     { s.actionStatus = v },
		SET_CATEGORIES(s, v)        { s.categories = v },
		SET_CATEGORIES_STATUS(s, v) { s.categoriesStatus = v },
		SET_CERTIFICATIONS(s, v)    { s.certifications = v },
		SET_CERTIFICATIONS_STATUS(s, v) { s.certificationsStatus = v },
		SET_TRAILS(s, v)            { s.trails = v },
		SET_TRAILS_STATUS(s, v)     { s.trailsStatus = v },
		SET_CURRENT_TRAIL(s, v)     { s.currentTrail = v },
		SET_CURRENT_TRAIL_STATUS(s, v) { s.currentTrailStatus = v },
		SET_ASSESSMENT_ACTIVITY(s, v)        { s.assessmentActivity = v },
		SET_ASSESSMENT_ACTIVITY_STATUS(s, v) { s.assessmentActivityStatus = v },
		SET_TRAIL_ACTIVITY(s, v)             { s.trailActivity = v },
		SET_TRAIL_ACTIVITY_STATUS(s, v)      { s.trailActivityStatus = v },
	},
	actions: {
		// ── Assessment CRUD ────────────────────────────────────────────────────
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listAssessments(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch { commit('SET_LIST_STATUS', 'error') }
		},
		async fetchOne({ commit }, id) {
			commit('SET_CURRENT_STATUS', 'pending')
			try {
				const { data } = await getAssessment(id)
				commit('SET_CURRENT', data.data)
				commit('SET_CURRENT_STATUS', 'init')
			} catch { commit('SET_CURRENT_STATUS', 'error') }
		},
		async create({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await createAssessment(payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async update({ commit }, { id, ...payload }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateAssessment(id, payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async remove({ commit }, id) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await deleteAssessment(id)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async publish({ commit }, id) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await publishAssessment(id)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async generateAi({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await generateAiAssessment(payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async approveAi({ commit }, id) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await approveAiAssessment(id)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async rejectAi({ commit }, { id, reason }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await rejectAiAssessment(id, reason)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},

		// ── Categories ─────────────────────────────────────────────────────────
		async fetchCategories({ commit }, params) {
			commit('SET_CATEGORIES_STATUS', 'pending')
			try {
				const { data } = await listCategories(params)
				commit('SET_CATEGORIES', data.data || data)
				commit('SET_CATEGORIES_STATUS', 'init')
			} catch { commit('SET_CATEGORIES_STATUS', 'error') }
		},
		async createCategory({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await createCategory(payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async updateCategory({ commit }, { id, ...payload }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateCategory(id, payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async removeCategory({ commit }, id) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await deleteCategory(id)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},

		// ── Certifications ─────────────────────────────────────────────────────
		async fetchCertifications({ commit }, params) {
			commit('SET_CERTIFICATIONS_STATUS', 'pending')
			try {
				const { data } = await listCertifications(params)
				commit('SET_CERTIFICATIONS', data)
				commit('SET_CERTIFICATIONS_STATUS', 'init')
			} catch { commit('SET_CERTIFICATIONS_STATUS', 'error') }
		},

		// ── Career Trails ──────────────────────────────────────────────────────
		async fetchTrails({ commit }, params) {
			commit('SET_TRAILS_STATUS', 'pending')
			try {
				const { data } = await listCareerTrails(params)
				commit('SET_TRAILS', data)
				commit('SET_TRAILS_STATUS', 'init')
			} catch { commit('SET_TRAILS_STATUS', 'error') }
		},
		async fetchOneTrail({ commit }, id) {
			commit('SET_CURRENT_TRAIL_STATUS', 'pending')
			commit('SET_CURRENT_TRAIL', null)
			try {
				const { data } = await getCareerTrail(id)
				commit('SET_CURRENT_TRAIL', data.data)
				commit('SET_CURRENT_TRAIL_STATUS', 'init')
				return data.data
			} catch { commit('SET_CURRENT_TRAIL_STATUS', 'error') }
		},
		async createTrail({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await createCareerTrail(payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async updateTrail({ commit }, { id, ...payload }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateCareerTrail(id, payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async removeTrail({ commit }, id) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await deleteCareerTrail(id)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async addLevel({ commit }, { trailId, ...payload }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await storeTrailLevel(trailId, payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async editLevel({ commit }, { trailId, levelId, ...payload }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateTrailLevel(trailId, levelId, payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async removeLevel({ commit }, { trailId, levelId }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await deleteTrailLevel(trailId, levelId)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async addStep({ commit }, { trailId, levelId, ...payload }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await storeTrailStep(trailId, levelId, payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async editStep({ commit }, { trailId, levelId, stepId, ...payload }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateTrailStep(trailId, levelId, stepId, payload)
				commit('SET_ACTION_STATUS', 'success')
				return data
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},
		async removeStep({ commit }, { trailId, levelId, stepId }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await deleteTrailStep(trailId, levelId, stepId)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) { commit('SET_ACTION_STATUS', 'error'); throw e }
		},

		// ── Live Activity ──────────────────────────────────────────────────────
		async fetchAssessmentActivity({ commit }, params) {
			commit('SET_ASSESSMENT_ACTIVITY_STATUS', 'pending')
			try {
				const { data } = await listAssessmentActivity(params)
				commit('SET_ASSESSMENT_ACTIVITY', data)
				commit('SET_ASSESSMENT_ACTIVITY_STATUS', 'init')
			} catch { commit('SET_ASSESSMENT_ACTIVITY_STATUS', 'error') }
		},
		async fetchTrailActivity({ commit }, params) {
			commit('SET_TRAIL_ACTIVITY_STATUS', 'pending')
			try {
				const { data } = await listCareerTrailActivity(params)
				commit('SET_TRAIL_ACTIVITY', data)
				commit('SET_TRAIL_ACTIVITY_STATUS', 'init')
			} catch { commit('SET_TRAIL_ACTIVITY_STATUS', 'error') }
		},
	},
}
